<div class="guest-verify-container">
  <!-- Left Side - Verification Form -->
  <div class="verify-side">
    <div class="verify-panel">
      <div class="panel-header">
        <mat-icon class="header-icon">verified_user</mat-icon>
        <h2 class="panel-title">Provjera gosta</h2>
      </div>

      <!-- Valamar Guest Toggle -->
      <div class="valamar-toggle-section">
        <div class="toggle-card">
          <div class="toggle-content">
            <mat-icon class="toggle-icon">card_membership</mat-icon>
            <div class="toggle-info">
              <span class="toggle-label">Valamar gost</span>
              <span class="toggle-description">Provjeri status gosta u Valamar sustavu</span>
            </div>
          </div>
          <mat-slide-toggle
            [(ngModel)]="isValamarGuest"
            (change)="onValamarGuestChange($any($event))"
            class="valamar-toggle"
          ></mat-slide-toggle>
        </div>
      </div>

      <!-- Search Form (shown when Valamar guest is checked) -->
      <div *ngIf="isValamarGuest" class="search-form-container">
        <div class="form-section-title">
          <mat-icon>search</mat-icon>
          <span>Pretraga bookinga</span>
        </div>

        <div class="search-form">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>
              <mat-icon class="label-icon">hotel</mat-icon>
              Hotel
            </mat-label>
            <mat-select #hotelSelect [(ngModel)]="propertyCode" panelClass="hotel-select-panel">
              <div class="hotel-search-panel">
                <mat-icon class="search-icon">search</mat-icon>
                <input
                  matInput
                  class="hotel-search-input"
                  [(ngModel)]="propertySearchTerm"
                  (input)="filterProperties()"
                  placeholder="Pretraži hotele..."
                  autocomplete="off"
                />
              </div>
              <mat-option *ngFor="let prop of filteredProperties" [value]="prop.code">
                <span class="option-name">{{ prop.name }}</span>
                <span class="property-code">({{ prop.code }})</span>
              </mat-option>
              <mat-option *ngIf="filteredProperties.length === 0 && propertySearchTerm" disabled>
                Nema pronađenih hotela
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>
              <mat-icon class="label-icon">door_front</mat-icon>
              Broj sobe
            </mat-label>
            <input matInput [(ngModel)]="roomNumber" placeholder="npr. 205" />
          </mat-form-field>

          <div class="search-buttons">
            <button
              mat-button
              (click)="onClear()"
              [disabled]="loading"
              class="btn-clear"
            >
              <mat-icon>refresh</mat-icon>
              Očisti
            </button>
            <button
              mat-raised-button
              color="primary"
              (click)="onSearch()"
              [disabled]="loading || !propertyCode || !roomNumber"
              class="btn-search"
            >
              <mat-icon *ngIf="!loading">search</mat-icon>
              <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
              <span *ngIf="!loading">Pretraži</span>
            </button>
          </div>
        </div>

        <!-- Error Message -->
        <div *ngIf="error" class="error-message">
          <mat-icon>error_outline</mat-icon>
          <span>{{ error }}</span>
        </div>

        <!-- Operator Notice -->
        <div *ngIf="searchResults.length > 0" class="operator-notice">
          <mat-icon>warning</mat-icon>
          <div class="notice-content">
            <strong>Pažnja:</strong> Sva odgovornost je na operateru da potvrdi da je u pitanju Valamar gost.
          </div>
        </div>
      </div>

      <!-- Non-Valamar Info -->
      <div *ngIf="!isValamarGuest" class="non-valamar-info">
        <div class="info-content">
          <mat-icon class="info-icon">info</mat-icon>
          <div class="info-text">
            <h3>External postupak</h3>
            <p>Gost nije Valamar gost. Nastavljamo sa external postupkom bez posebnih popusta.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Side - Results & Confirmed Guest -->
  <div class="results-side">
    <!-- Empty State -->
    <div *ngIf="!selectedBooking && searchResults.length === 0" class="empty-state">
      <div class="empty-state-content">
        <mat-icon class="empty-icon">fact_check</mat-icon>
        <h3>Nema rezultata</h3>
        <p *ngIf="!isValamarGuest">Čekanje potvrde gosta...</p>
        <p *ngIf="isValamarGuest">Unesite podatke za pretragu Valamar bookinga</p>
      </div>
    </div>

    <!-- Search Results -->
    <div *ngIf="searchResults.length > 0 && !selectedBooking" class="results-container">
      <div class="results-header">
        <mat-icon class="header-icon">list_alt</mat-icon>
        <div class="header-text">
          <h3>Pronađene rezervacije</h3>
          <p>{{ searchResults.length }} rezultata - Odaberite gosta</p>
        </div>
      </div>
      <div class="results-list">
        <mat-card
          *ngFor="let booking of searchResults"
          class="result-card"
          [class.selected]="selectedBooking === booking"
          (click)="selectBooking(booking)"
        >
          <mat-card-content>
            <div class="booking-header">
              <span class="holder-badge">Klikni za potvrdu</span>

              <span class="booking-name">
                {{ booking.accountData?.firstName }} {{ booking.accountData?.lastName }}
              </span>
              <span *ngIf="booking.vlevel" class="vlevel-badge">
                <mat-icon>workspace_premium</mat-icon>
                V-Level
              </span>
              <span *ngIf="!booking.vlevel" class="standard-badge">Standard</span>
            </div>
            <div class="booking-details">
              <div class="detail-row">
                <mat-icon>hotel</mat-icon>
                <span>{{ booking.property }} - Soba {{ booking.roomNumber }}</span>
              </div>
              <div class="detail-row">
                <mat-icon>event</mat-icon>
                <span>{{ booking.checkIn | date:'dd.MM.yyyy' }} → {{ booking.checkOut | date:'dd.MM.yyyy' }}</span>
              </div>
              <div class="detail-row">
                <mat-icon>email</mat-icon>
                <span>{{ booking.accountData?.email }}</span>
              </div>
              <div *ngIf="booking.staysData && booking.staysData.length > 0" class="stays-info">
                <div class="stays-title">Gosti u sobi:</div>
                <div class="stays-list">
                  <div *ngFor="let stay of booking.staysData" class="stay-item">
                    <span class="stay-name">{{ stay.firstName }} {{ stay.lastName }}</span>
                    <span *ngIf="stay.isHolder" class="holder-badge">
                      <mat-icon>person</mat-icon>
                      Booker
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <!-- Confirmed Guest -->
    <div *ngIf="selectedBooking" class="confirmed-guest">
      <div class="confirmed-header">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <div class="confirmed-text">
          <h3>Potvrđen gost</h3>
          <p>Booking selektiran za check-in</p>
        </div>
      </div>

      <mat-card class="confirmed-card">
        <button
          mat-icon-button
          (click)="onCancelSelection()"
          class="cancel-btn"
          matTooltip="Odustani od potvrđenog gosta"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-card-content>
          <div class="guest-info">
            <div class="guest-avatar">
              <mat-icon *ngIf="vLevel">workspace_premium</mat-icon>
              <mat-icon *ngIf="!vLevel">person</mat-icon>
            </div>
            <div class="guest-details">
              <div class="guest-name">{{ bookerName }}</div>
              <div class="guest-email">{{ selectedBooking.accountData?.email }}</div>
              <div class="guest-location">
                <mat-icon>hotel</mat-icon>
                {{ selectedBooking.property }} - Soba {{ selectedBooking.roomNumber }}
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

<!--    <div class="package-selector">-->
<!--      <div class="package-label">-->
<!--        <mat-icon>card_membership</mat-icon>-->
<!--        <span>Odabir paketa kredita:</span>-->
<!--      </div>-->
<!--      <mat-button-toggle-group-->
<!--        [(value)]="selectedPackage"-->
<!--        (change)="onPackageChange($any($event).value)"-->
<!--        class="package-toggle-group"-->
<!--      >-->
<!--        <mat-button-toggle value="external" class="package-toggle external-toggle">-->
<!--          <mat-icon>card_membership</mat-icon>-->
<!--          <span>External</span>-->
<!--          <span class="percentage">40%</span>-->
<!--        </mat-button-toggle>-->
<!--        <mat-button-toggle value="collection" class="package-toggle collection-toggle">-->
<!--          <mat-icon>card_membership</mat-icon>-->
<!--          <span>Collection</span>-->
<!--          <span class="percentage">60%</span>-->
<!--        </mat-button-toggle>-->
<!--        <mat-button-toggle value="vlevel" class="package-toggle vlevel-toggle">-->
<!--          <mat-icon>workspace_premium</mat-icon>-->
<!--          <span>V-Level</span>-->
<!--          <span class="percentage">100%</span>-->
<!--        </mat-button-toggle>-->
<!--      </mat-button-toggle-group>-->
<!--      <div class="package-info">-->
<!--        <span class="package-hint" *ngIf="selectedPackage === 'external'">-->
<!--                    Standardni popust-->
<!--                  </span>-->
<!--        <span class="package-hint collection-hint" *ngIf="selectedPackage === 'collection'">-->
<!--                    Valamar popust-->
<!--                  </span>-->
<!--        <span class="package-hint premium-hint" *ngIf="selectedPackage === 'vlevel'">-->
<!--                    Premium status - puni kredit-->
<!--                  </span>-->
<!--      </div>-->
<!--    </div>-->

  </div>


  <!-- Action Buttons -->
  <div class="action-buttons">
    <button mat-button (click)="onBack()" class="btn-back">
      <mat-icon>arrow_back</mat-icon>
      Natrag
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onConfirm()"
      [disabled]="!canContinue"
      class="btn-confirm"
    >
      Nastavi
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
